module.exports = __webpack_public_path__ + "img/dinners.d8bb2925.svg";